// removed by extract-text-webpack-plugin
module.exports = {"root":"loyalty--root--1fCwLmoz home--root--2rXwqQ3Z organization-home--root--29mpR9MJ"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/loyalty/styles.css
// module id = ./views/refunds/loyalty/styles.css
// module chunks = 0